<template>
<div class="kpt-job-detail" v-if="job && !isLoading">
    <vue-headful :title="title" />
    <header class="kpt-detail-pane-header">
      <h4><span>{{job.id}}</span></h4>
      <div class="page-control block">
        <font-awesome-icon :icon="['far', 'times-circle']" size="lg" @click="close" title="Close" />
      </div>
    </header>
    <div class="kpt-detail-main">
      <div class="kpt-detail-content">
        <pre>{{job}}</pre>
      </div>
    </div>
  </div>
  <div v-else-if="!job && !isLoading && notFound">
    Job not found.
  </div>
  <div class="kpt-detail-loading" v-else>
    <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      notFound: false
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      this.isLoading = true;
      const result = await this.$store.dispatch('fetchJob', { id: this.$route.params.id });
      this.isLoading = false;
      if (!result) this.notFound = true;
    }
  },
  computed: {
    job() {
      return this.$store.state.jobs.job;
    },
    title() {
      return `Job Id: ${this.$store.state.jobs.job.id}`;
    }
  },
  methods: {
    close() {
      this.$router.push({ path: '/jobs' });
    }
  }
}
</script>
